<style scoped>
.table-sticky {
    border-collapse: separate;
    border-spacing: 0;
}

.table-sticky * {
    border-collapse: separate;
    border-spacing: 0;
}

.table-sticky > thead {
    z-index: 1;
    position: sticky;
    top: 0;
}

body {
    --wp--style--global--content-size: 95%;
}
</style>

<template>
    <div>
        <h1 class="entry-title">Results</h1>

        <div class="row my-2">
            <h2 class="h6">Your Search:</h2>

            <div>
                <template v-for="values, key, index in queryObj">
                    <template v-if="index > 0">
                        <br />
                        <span>&nbsp;AND&nbsp;</span>
                    </template>
                    <span>{{ lookupField(key)?.name }}</span>
                    <span v-if="true">{{ printValues(key, values) }}</span>
                    <span v-else-if="values.length == 1">
                        = {{ values[0] }}
                    </span>
                    <span v-else>
                        = {{ values.join('&nbsp;OR&nbsp;') }}
                    </span>
                </template>
            </div>
        </div>

        <div class="row">
            <div>{{ resultsCount }} results match your search</div>

            <div class="btn-group mb-3">
                <a :href="searchURL" class="btn btn-inverse-black mx-1">Modify Search</a>
                <button @click="copyResultsLink()" class="btn btn-inverse-black mx-1">Copy results link</button>

                <button @click="showColumnsModal = true" class="btn btn-inverse-black mx-1">Show additional columns</button>
            </div>
        </div>

        <div class="row px-2">
            <div class="table-responsive overflow-auto sticky-top" style="max-height: 80vh;">
                <table class="table table-striped table-bordered table-sticky table-hover">
                    <thead class="table-light border border-dark">
                        <tr class="border border-dark">
                            <th v-for="field in visibleFields" class="border border-light text-nowrap"  style="min-width: 15rem;">
                                {{ lookupField(field)?.name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in results">
                            <template v-for="field in visibleFields">
                                <td v-if="field == 'state'">
                                    <a :href="'/vi-eligibility-criteria/state/' + stringToSlug(row.state)">{{ row.state }}</a>
                                </td>

                                <td v-else-if="fieldHasOptions(field)">
                                    {{ decodeValue(field, row[field]) }}
                                </td>

                                <td v-else>
                                    {{ row[field] }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ColumnsModal :fields="fieldsForDict" :query="queryObj" v-model="showColumnsModal" v-model:choices="userFields"></ColumnsModal>
    </div>
</template>
  
<script>
import ColumnsModal from "../components/ColumnsModal.vue";
import { stringToSlug, simpleGroupBy } from "../lib/util.js";
import { visible_sections } from "../lib/project";

export default {
    props: ['data', 'dict'],
    components: {
        ColumnsModal,
    },

    data() {
        return {
            sections: [
                "state",
                ...visible_sections
            ],
            query: {},
            userFields: [],
            showColumnsModal: false,

        };
    },

    mounted() {
        let params = new URLSearchParams(document.location.search);

        /** Decode query from url */
        try {
            let encoded = params.get("query");
            let b64 = decodeURIComponent(encoded);

            if (b64) {
                let json = atob(b64);
                let query = JSON.parse(json);

                if (query) {
                    console.info(`loaded query from URL`);
                    Object.assign(this.query, query);
                }
            }
        } catch {
            Object.assign(this.query, {});
        }

        /** decode extra columns from url */
        try {
            let encoded = params.get("columns");
            let b64 = decodeURIComponent(encoded);

            if (b64) {
                let json = atob(b64);
                let columns = JSON.parse(json);

                if (columns) {
                    console.info(`loaded columns from URL`);
                    this.userFields = [...columns];
                }
            }
        } catch {
            this.userFields = [];
        }


    },

    methods: {
        stringToSlug,
        lookupField(key) {
            return this.fieldsForDict.find(field => field.label === key);
        },
        fieldHasOptions(key) {
            let field = this.lookupField(key);
            let hasOptions = Object.keys(field.coding).length > 0;

            return hasOptions;
        },
        decodeValue(key, value) {
            let field = this.lookupField(key);
            let hasOptions = Object.keys(field.coding).length > 0;

            return hasOptions ? field.coding[value] : value;
        },

        /* display query to user */
        printValues(key, values) {
            let field = this.lookupField(key);

            if (!field) {
                return '';
            }

            let hasOptions = Object.keys(field.coding).length > 0;

            if (hasOptions) {
                return ' = ' + values.map(v => field.coding[v]).join(' OR ');
            } else {
                if (field.type == 'varchar') {
                    return ' includes "' + values.join(' OR ') + '"';
                } else {
                    return ' = ' + values.join(' OR ');
                }
            }
        },
        copySearchLink() {
            navigator.clipboard.writeText(this.searchURL);
        },
        copyResultsLink() {
            navigator.clipboard.writeText(this.resultsURL);
        },
    },

    computed: {

        /** map backend data into useful structure for frontend */
        fieldsForDict() {
            return this.dict.dict.map((def) => {

                if (def.section_table_name === 'fx_aph_nptp' && def.field_column_name === 'state') {

                    return {
                        coding: Object.fromEntries(this.dict.states.map(state => [state, state])),
                        section_slug: 'state',
                        section_title: 'State',
                        description: '',
                        label: 'state',
                        name: 'State',
                        notes: '',
                        type: 'varchar',
                    };


                }


                return {
                    coding: def.field_column_type === 'bit' ? { 0: 'No', 1: 'Yes' } : Object.fromEntries(JSON.parse(def.field_options).map(opt => [opt.value, opt.label])),
                    section_slug: stringToSlug(def.section_title),
                    section_title: def.section_title,
                    description: def.field_config_hint,
                    label: def.field_title,
                    name: def.field_config_extended_label,
                    notes: def.field_config_help_text,
                    type: def.field_column_type,
                };
            });
        },

        /** Display fixed columns + query colums + user columns */
        visibleFields() {
            const always = ['state'];
            let queryFields = Object.keys(this.query);
            let userFields = this.userFields;

            return [...new Set([...always, ...queryFields, ...userFields])];

        },

        /** Query as object, ignoring fields with no values to query */
        queryObj() {
            return Object.fromEntries(
                Object.entries(this.query)
                    .filter(([key, value]) => Array.isArray(value) && value.length));

        },
        queryToString() {
            return JSON.stringify(this.queryObj);
        },
        queryToUrlParam() {
            let base64encoded = btoa(this.queryToString);
            return encodeURIComponent(base64encoded);
        },

        columnsToURLParam() {
            let data = JSON.stringify(this.userFields);
            return encodeURIComponent(btoa(data));
        },

        searchURL() {
            let url = new URL(window.location);
            url.hash = '';
            url.pathname = '/vi-eligibility-criteria/search';
            url.searchParams.set('query', this.queryToUrlParam);
            url.searchParams.set('columns', this.columnsToURLParam);
            return url.toString();
        },

        resultsURL() {
            let url = new URL(window.location);
            url.hash = '';
            url.pathname = '/vi-eligibility-criteria/results';
            url.searchParams.set('query', this.queryToUrlParam);
            url.searchParams.set('columns', this.columnsToURLParam);
            return url.toString();
        },


        groupedFields() {
            return simpleGroupBy(this.fieldsForDict, "section_slug");
        },
        groups() {
            return simpleGroupBy(this.fieldsForDict, "section_slug", 'None', (def) => def.label);
        },

        glabels() {
            return Object.fromEntries(Object.keys(this.groupedFields).map(key => [key, this.groupedFields[key][0].section_title]));
        },

        results() {
            let results = this.data.filter(record => {

                let match = true;

                Object.keys(this.queryObj).forEach(key => {
                    let field = this.fieldsForDict.find(field => field.label === key);

                    let hasOpts = Object.keys(field.coding).length > 0;

                    if (hasOpts || field.type === 'bit') {
                        match = match && this.queryObj[key].includes(`${record[key]}`);
                    } else {
                        if (field.type === 'integer') {
                            match = match && this.queryObj[key].includes(record[key]);
                        } else {
                            //partial string match on text field
                            match = match && record[key].toLowerCase().includes(record[key].toLowerCase().trim());
                        }
                    }
                });
                return match;
            });

            return results;
        },

        resultsCount() {
            return this.results.length;
        }
    },
    watch: {
        resultsURL() {
            history.replaceState(null, '', this.resultsURL);
        }
    },
}
</script>
  
<style>
.row-scroll {
    max-height: 300px;
    overflow-y: auto;
}
</style>